module.exports = __webpack_public_path__ + "img/block2-2-mobile.3b6866e5.jpg";